import { deleteMessagesEpic } from './state/delete-messages.epic';
import { loadEpic } from './state/load.epic';
import { reloadEpic } from './state/reload.epic';
import { sendMessageEpic } from './state/send-message.epic';
import { updateChatEpic } from './state/update-chat.epic';

export const teamschatDialogEpics = [
    loadEpic,
    reloadEpic,
    sendMessageEpic,
    deleteMessagesEpic,
    updateChatEpic,
];
